// extracted by mini-css-extract-plugin
export default {"chat-app":"App_chat-app__ig6hI"};